import { FC } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { faComment } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Hyperlink, Tooltip } from '@ebsco-ui/ebsco-ui';

import { FeatureFlagDisplay } from '@app/components';
import { Feature } from '@app/constants';

import css from './LibraryChatButton.module.scss';

interface LibraryChatButtonProps {
  isBackToTopVisible: boolean;
}

export const LibraryChatButton: FC<LibraryChatButtonProps> = ({
  isBackToTopVisible,
}) => {
  const { $t } = useIntl();

  const buttonMessage = $t({
    id: 'messages.chatWithALibrarian',
    defaultMessage: 'Chat with a librarian',
  });

  return (
    <FeatureFlagDisplay
      flagToMatch={{ name: Feature.libraryChat }}
      renderOn={({ config: { chatUrl } }) => (
        <Tooltip
          title={buttonMessage}
          placement="left"
          zIndex={1001}
          className={css.tooltip}
        >
          <Hyperlink
            className={cn(css.libraryChatButton, {
              [css.slide]: isBackToTopVisible,
            })}
            href={chatUrl}
            target="_blank"
            aria-label={buttonMessage}
          >
            <FontAwesomeIcon icon={faComment} className={css.icon} />
          </Hyperlink>
        </Tooltip>
      )}
    />
  );
};
